module.exports = __webpack_public_path__ + "static/media/img-placeholder.fc89825e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-placeholder.jpg
// module id = 294
// module chunks = 0